import { RouteRecordRaw } from "vue-router";

const administrativeRoutes: Array<RouteRecordRaw> = [
  {
    path: "/administrative",
    name: "administrative",
    component: () => import("@/views/administrative/index.vue"),
    meta: { requiresAuth: true, permission: "administrativo" },
    children: [
      {
        path: "activities",
        name: "administrative-activities",
        component: () =>
          import("@/views/administrative/activities/index.vue"),
        meta: { requiresAuth: true, permission: "administrativo_actividades" },
      },
      // actives
      {
        path: "actives",
        name: "administrative-actives",
        redirect: {
          name: "administrative-actives-list",
        },
        component: () => import("@/views/administrative/actives/index.vue"),
        meta: {
          requiresAuth: true,
          permission: "administrativo_activos",
        },
        children: [
          {
            path: "add",
            name: "administrative-actives-add",
            component: () =>
                import("@/views/administrative/actives/formActives.vue"),
            meta: {
              requiresAuth: true,
              permission: "administrativo_activos",
            },
          },
          {
            path: "edit/:id",
            props: true,
            name: "administrative-actives-edit",
            component: () =>
                import("@/views/administrative/actives/formActives.vue"),
            meta: {
              requiresAuth: true,
              permission: "administrativo_activos",
            },
          },
          {
            path: "list",
            name: "administrative-actives-list",
            component: () =>
                import("@/views/administrative/actives/listActives.vue"),
            meta: {
              requiresAuth: true,
              permission: "administrativo_activos",
            },
          },
        ],
      },
      // Generador de Reportes
      {
        path: "report-generator",
        name: "administrative-report-generator",
        component: () =>
          import("@/views/administrative/report-generator/ReportGenerator.vue"),
        meta: { requiresAuth: true, permission: "generador_reportes" },
      },
      {
        path: "report-templates",
        name: "administrative-report-templates",
        component: () =>
          import("@/views/administrative/report-generator/ReportTemplates.vue"),
        meta: { requiresAuth: true, permission: "generador_reportes" },
      },
      // Copias de Seguridad
      {
        path: "backups",
        name: "administrative-backups",
        component: () =>
          import("@/views/administrative/backups/BackupList.vue"),
        meta: { requiresAuth: true, permission: "copias_seguridad" },
      },
      // Registros Duplicados
      {
        path: "duplicates",
        name: "administrative-duplicates",
        component: () =>
          import("@/views/administrative/duplicates/DuplicateList.vue"),
        meta: { requiresAuth: true, permission: "registros_duplicados" },
      },
    ],
  },
];

export default administrativeRoutes;
